export default __webpack_public_path__ + "static/media/no_compute.fcb1bb80.svg";